export const SITE_URL = "https://lazonarestorative.com";

export const SITE_NAME = "Lazona Tile Care";
